import React from 'react';

interface LabelIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const LabelIcon: React.FC<LabelIconProps> = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_39914_48232)">
      <path
        d="M13.7671 5L13.9535 5.01058C14.1386 5.03152 14.3194 5.0833 14.4881 5.16439C14.7131 5.27257 14.9115 5.43011 15.0675 5.625L18.151 9.47917C18.3945 9.78352 18.3945 10.2165 18.151 10.5208L15.0675 14.375C14.9115 14.5699 14.7131 14.7274 14.4881 14.8356C14.2632 14.9437 14.0167 14.9998 13.7671 15H5C4.33696 15 3.70126 14.7364 3.23242 14.2676C2.76358 13.7987 2.5 13.163 2.5 12.5V7.5C2.5 6.83696 2.76358 6.20126 3.23242 5.73242C3.70126 5.26358 4.33696 5 5 5H13.7671ZM4.16667 12.5L4.17074 12.5822C4.18964 12.773 4.27402 12.9524 4.41081 13.0892C4.56709 13.2455 4.77899 13.3333 5 13.3333H13.7663L16.4323 10L13.7663 6.66667H5C4.77899 6.66667 4.56709 6.75453 4.41081 6.91081C4.25453 7.06709 4.16667 7.27899 4.16667 7.5V12.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_39914_48232">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

